import { useEffect, useState } from 'react';
import { cn } from '../../../lib/utils';
import {
  primaryText,
  secondaryText,
  semiBoldText,
  smallTextSize,
} from '../../../styling/stylingHelper';
import { AdminLayout } from './AdminLayout';
import { getAdminRestaurantsList, AdminRestaurant } from '../../../services/admin/adminService';
import { GenerateReportCard } from './communication/GenerateReportCard';
import { CustomEmailCard } from './communication/CustomEmailCard';
import { TemplatedEmailCard } from './communication/TemplatedEmailCard';

/** Every manual report/email send surface — settings live on AdminCommunicationSettingsPage. */
const AdminCommunicationReportsPage = () => {
  const [restaurants, setRestaurants] = useState<AdminRestaurant[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const list = await getAdminRestaurantsList();
        setRestaurants(list);
      } catch (err) {
        console.error('Failed to load restaurants:', err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <div className={secondaryText}>Loading...</div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h2 className={cn(primaryText, 'text-lg', semiBoldText)}>Send Reports</h2>
          <p className={cn(secondaryText, smallTextSize, 'mt-1')}>
            Every manual report or email send. Weekly report settings live on the Settings tab.
          </p>
        </div>

        <GenerateReportCard restaurants={restaurants} />
        <CustomEmailCard />
        <TemplatedEmailCard />
      </div>
    </AdminLayout>
  );
};

export default AdminCommunicationReportsPage;
